var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.72032 12.53C7.57987 12.3894 7.50098 12.1988 7.50098 12C7.50098 11.8013 7.57987 11.6106 7.72032 11.47L15.2203 3.97C15.289 3.89631 15.3718 3.83721 15.4638 3.79622C15.5558 3.75523 15.6551 3.73319 15.7558 3.73141C15.8565 3.72963 15.9565 3.74816 16.0499 3.78588C16.1433 3.8236 16.2281 3.87974 16.2994 3.95096C16.3706 4.02218 16.4267 4.10702 16.4644 4.2004C16.5022 4.29379 16.5207 4.39382 16.5189 4.49452C16.5171 4.59523 16.4951 4.69454 16.4541 4.78654C16.4131 4.87854 16.354 4.96134 16.2803 5.03L9.31032 12L16.2803 18.97C16.354 19.0387 16.4131 19.1215 16.4541 19.2135C16.4951 19.3055 16.5171 19.4048 16.5189 19.5055C16.5207 19.6062 16.5022 19.7062 16.4644 19.7996C16.4267 19.893 16.3706 19.9778 16.2994 20.049C16.2281 20.1203 16.1433 20.1764 16.0499 20.2141C15.9565 20.2518 15.8565 20.2704 15.7558 20.2686C15.6551 20.2668 15.5558 20.2448 15.4638 20.2038C15.3718 20.1628 15.289 20.1037 15.2203 20.03L7.72032 12.53Z",
    fill: "#474F63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/backArrow.a20f88be46a06df955fe010ad06fa686.svg";
export { ForwardRef as ReactComponent };